import { useHistory, useLocation } from "react-router-dom";
import _ from "lodash";
import { useEffect } from "react";

const useFilter = ({ paramName, values = [], initialValue = null }) => {
  const { pathname, search } = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(search);
  const currentQuery = searchParams.get(paramName);

  const updateParams = (searchParams, value) => {
    if (_.isNil(value)) {
      searchParams.delete(paramName);
    } else {
      searchParams.set(paramName, value);
    }
  };

  const updateUrl = (value, forceSearchParams = null) => {
    if (forceSearchParams) {
      updateParams(forceSearchParams, value);
      history.push({ pathname, search: forceSearchParams.toString() });
    } else {
      updateParams(searchParams, value);
      history.push({ pathname, search: searchParams.toString() });
    }

    return forceSearchParams || searchParams;
  };

  useEffect(() => {
    if (!currentQuery && initialValue) {
      updateUrl(initialValue);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterData = { filter: updateUrl, currentQuery };

  values.forEach((value) => {
    filterData[_.camelCase(`${paramName}To_${value}`)] = () => updateUrl(value);
  });

  return filterData;
};

export default useFilter;
